import React,{ useRef,useMemo } from 'react';
import { useTable, useGlobalFilter, useFilters, usePagination } from 'react-table';
import MOCK_DATA from '../jsx/components/table/FilteringTable/MOCK_DATA_2.json';
import { COLUMNS } from '../jsx/components/table/FilteringTable/ColumnsComExpenses copy';
 import { Link,useNavigate } from "react-router-dom";
 import axios from "axios";
 import swal from 'sweetalert'; 
import '../jsx/components/table/FilteringTable/filtering.css';
import { Col, Row ,Dropdown} from 'react-bootstrap';
import InviteCustomer1 from '../jsx/constant/Employeeexpences';
import InviteCustomer from '../jsx/constant/EditCompanyExpenses';
import InviteCustomer2 from '../components/SanadSaref1';

import  { useEffect,useState     } from 'react';


export const CompanyExpenses = () => {
	const columns = useMemo( () => COLUMNS, [] )
	//const data = useMemo( () => MOCK_DATA, [] )
  const [data, setData] = useState([])
  const [data2, setData2] = useState([])

  const [ID, setID] = useState(0)
  const [inviteModal , setInviteModal] = useState(false);
	const tableInstance = useTable({
		columns,
		data,	
		initialState : {pageIndex : 0}
	}, useFilters, useGlobalFilter, usePagination)
	
	const { 
		getTableProps, 
		getTableBodyProps, 
		headerGroups, 
		prepareRow,
		state,
		page,
		gotoPage,
		pageCount,
		pageOptions,
		nextPage,
		previousPage,
		canNextPage,
		canPreviousPage,
		setGlobalFilter,
	} = tableInstance
    const {globalFilter, pageIndex} = state	
    const navigate = useNavigate();

    const userdata = useRef();
    const invite1 = useRef();
    const invite = useRef();
    const invite2 = useRef();
    //================================================================
    const userPermissionsJSON = localStorage.getItem('USER_PERMISSIONS2');
    const userPermissions = JSON.parse(userPermissionsJSON);
    function getActionsForPage(pageName) {
      const pagePermissions = userPermissions.find(permission => permission.resource === pageName);
   console.log('actionsForPage',pagePermissions); 
     if (pagePermissions) {
         return pagePermissions.action;
     } else {
    navigate('/dashboard_1')
        return [];
     }
   }
   const pageName = 'Empolyee';
   const actionsForPage = getActionsForPage(pageName);

   //=============================================================================================
    useEffect(() => {
      fetchProducts();
  }, [])

  const fetchProducts = async () => {
      await axios.get('https://subk.education.com.ly/back/api/empexpences').then(({ data }) => {setData(data)}) 
  }
    const deleteUser = async (e,id)=> {
        e.preventDefault();
        swal({
          title: "هل متأكد من الحدف",
          text: " في حال حدف الملف لايمكنك استعادة هدا الملف",
          icon: "warning",
          buttons: true,
          dangerMode: true,
        })
        .then(willDelete => {
          if (willDelete) {
    
            axios.delete(`https://subk.education.com.ly/back/api/expenses/${id}`)
            
              .then(res => {
                fetchProducts();
                swal({
                  title: "تم",
                  text: "تم الحدف بنجاح",
                  icon: "success",
                  timer: 2000,
                  button: false
                })
                navigate('#')
            
               
            });
        
          } else {
            swal("تم الغاء عملية الحدف");
          }
        
        });
    
    };
    const svg1 = (
        <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <rect x="0" y="0" width="24" height="24"></rect>
            <circle fill="#000000" cx="5" cy="12" r="2"></circle>
            <circle fill="#000000" cx="12" cy="12" r="2"></circle>
            <circle fill="#000000" cx="19" cy="12" r="2"></circle>
          </g>
        </svg>
    )
  const sanadsarf = async (e,id)=> {
      console.log(id);
      data.map((item) => {
        if (id == item.ReceiptExpenseID) {
          setData2(item)}})
        
                invite.current.showInviteModal()

      setID(id); 
     }
    const EditData = async (e,id)=> {
      console.log(id);
      data.map((item) => {
        if (id == item.ReceiptExpenseID) {
          setData2(item)}})
        
        
      setID(id);setInviteModal(true)
     // invite.current.showEmployeModal()
    }
    const show =(value)=>
{
setInviteModal(value)

}
const [totalSum, setTotalSum] = useState(0);
useEffect(() => {
  // Calculate the total sum of the amounts whenever `data` changes
  let sum = 0;
  page.forEach(item => {
    const amountStr = item.values?.Amount || item.original?.Amount;
    const amount = parseFloat(amountStr);
    if (!isNaN(amount)) {
      sum += amount;
    }
  });

  setTotalSum(sum);
}, [page]); // This useEffect runs whenever `data` changes
const handleAction = async (id, field, value) => {
 
  const error = await axios.put(`https://subk.education.com.ly/back/api/receiptexpenses/${id}`, {
    [field]: value,
  })
    .catch(function (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
      }
      console.log(error.config);
    });
    fetchProducts() 
}
   return(
<>
<div className='container-fluid'>
				 
                 <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting p-0">   

                 <div className="tbl-caption p-0"  style={{float:"left"}}>
                   <div>
                        < Link to={"#"} className="btn btn-primary btn-sm m-1" data-bs-toggle="offcanvas"
                                 onClick={() => invite1.current.showInviteModal()}
                               > + إضافة مصروفات </Link>   
                                  
                                                      

                            </div>
                            
                            
                             
                            
                        </div>  
                        <div className="col-md-4" style={{display :'flex'}}>
                              
                            <i style={{color: 'green'}} class="fa-solid fa-money-bill-transfer fa-xl m-2"></i>

          <label htmlFor="startMonth" style={{fontsize: '15px', fontWeight: 'bold',color: 'red'}}>  اجمالي الصرف :</label>
       <div style={{color: 'green'}}> 
       <strong>{totalSum}</strong>  
        </div>  </div>
                        </div>     
                   
                       
                        		 
								<div className="table-responsive">
									<table {...getTableProps()} className="table dataTable display table-hover">
										 <thead style={{ position: "sticky", top: 0, zIndex: 1 }}>                      

										{headerGroups.map(headerGroup => (
												<tr {...headerGroup.getHeaderGroupProps()}>
												      {headerGroup.headers.map((column) => (
                        // Check if the column accessor is 'age' and render accordingly
                        column.id !== 'ReceiptExpenseID' ? (
                          <th {...column.getHeaderProps()}>
                            {column.render('Header')}
                            {column.canFilter ? column.render('Filter') : null}
                          </th>
                        ) : null
                      ))}
                                                                   <th style={{ paddingBottom: "4.5rem" }}>واصل الاستلام</th>

												</tr>
										))}
										</thead> 
                                        <tbody {...getTableBodyProps()} className="" >
                                        
                                        {page.map((row) => {
                                            prepareRow(row)
                                            return(
                                                <tr {...row.getRowProps()}>

                                                    {row.cells.map((cell) => (
          // Check if the column accessor is 'age' and render accordingly
          cell.column.id !== 'ReceiptExpenseID' ? (
            <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
          ) :null
        ))}
 <td> <Link dir="rtl" className=""
                              to={"#"}
                              onClick={(e) => sanadsarf(e, row.original.ReceiptExpenseID)}
                            > <i class="fa-solid fa-file-lines fa-2x"></i>
                            </Link>

                            </td>

                                                     <td>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="success"
                        className="sharp i-false" 
                      >
                           {svg1}
                       </Dropdown.Toggle>
                      <Dropdown.Menu dir="rtl" className="dropdown-menu-right">
                        

                      {actionsForPage.includes('edit') && (

                        <Dropdown.Item>                               
                                                        
                         <Link to className=""
                               onClick={(e) =>EditData(e,row.original.ReceiptExpenseID)}
                               >تعديل
                            </Link>
                        </Dropdown.Item>
                      )}
                                                                             {actionsForPage.includes('edit') && (

                        <Dropdown.Item>                               
                                                        
                         <Link to className=""
                              onClick={() => handleAction(row.original.ReceiptExpenseID, 'status', 'تم الاسترجاع')}
                               >
                                ارجاع السلفة
                            </Link>
                        </Dropdown.Item>)}
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
									</table>



									<div className="d-flex justify-content-between mx-2">
										<span>
											الصفحه{' '}
											<strong>
												{pageIndex + 1} من {pageOptions.length}
											</strong>{''}
										</span>
										<span className="table-index ">
											ادهب الى : {' '}
											<input type="number" 
												className="ml-2"
												defaultValue={pageIndex + 1} 
												onChange = {e => { 
													const pageNumber = e.target.value ? Number(e.target.value) - 1 : 0 
													gotoPage(pageNumber)
												} } 
											/>
										</span>
									</div>
                                    <div className="text-center mb-3">  
                                        <div className="filter-pagination  mt-3">
                                            <button className="previous-button" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
                                                {/* {'<'} */}
                                                <i className='fa-solid fa-angle-right' />
                                            </button>
                                            
                                            <button className="previous-button" onClick={() => previousPage()} disabled={!canPreviousPage}>
                                                السابق
                                            </button>
                                            <button className="next-button" onClick={() => nextPage()} disabled={!canNextPage}>
                                                التالي
                                            </button>
                                            <button className="next-button" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
                                                {/* {'>'} */}
                                                <i className='fa-solid fa-angle-left' />
                                            </button>
                                        </div>
                                    </div>
								</div>
						 
						 
			</div>
            <InviteCustomer1
                ref={invite1}     
                parentFunction={fetchProducts}  
            /> 
             <InviteCustomer2
                 ref={invite} 
                data={data2}
                parentFunction={fetchProducts}  
                inviteModal={inviteModal}
                show={show}
            /> 
             <InviteCustomer
                                   

                data={data2}
                parentFunction={fetchProducts}  
                inviteModal={inviteModal}
                show={show}
            /> 
</>


    );
}
export default CompanyExpenses;